import { useCallback, useEffect, useMemo, useState } from "react";
import { storeAnomalieFilters } from "../../../../store/filter.slice";
import Layout from "../../../../layouts/Layout";
import SearchAndTotalSummary from "../search-total-summary/SearchAndTotalSummary";
import { useDispatch, useSelector } from "react-redux";
import { alertPlatform, getSearchOptions, markAsCheckedAPI } from "../../../../services/api";
import { RAW_FILTER_DATA } from "../../../../shared/common";
import * as PR from "../../../../prime-react/index";
import moment from 'moment';
import { useNavigate } from "react-router-dom";
import "./Anomalies.scss";
import { alertTypes } from "../graph-and-stats/GraphConfig";
import { currencyFormat, DateFormat } from "../../../../utils/reuse";
import AlertNotifications from "../alert-notifications/AlertNotifications";
import { useToast } from "../../../../context/ToastContext";
import { filterOptionsActions } from "../../../../store/FiltersOptions";
import { lightBulb } from "../../../../assets/images";

const Anomalies = () => {
    const pageDisplayCount = 200;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { showToast } = useToast();
    const sessionData = useSelector((state) => state.auth.sessionData);
    const headers = useMemo(() => {
        return { sessionid: sessionData.sessionId };
    }, [sessionData.sessionId]);
    const [defaultDate] = useState(() => {
        const nowUTC = new Date(new Date().toUTCString());
        const hourUTC = nowUTC.getUTCHours();

        const offsetDays = hourUTC >= 21 ? 1 : 2;

        const maxAllowedDate = new Date();
        maxAllowedDate.setUTCDate(nowUTC.getUTCDate() - offsetDays);

        return [maxAllowedDate, maxAllowedDate];
    });
    const [searchOptions, setSearchOptions] = useState({
        group: [],
        location: [],
        channel: []
    });
    const alertPlatformState = useSelector(state => state.alertPlatformFilter.anomalieFilters);
    const storedFilterOptions = useSelector((state) => state.filterOptions);
    const [searchRequest, setSearchRequest] = useState(alertPlatformState);
    const [defaultGroup, setDefaultGroup] = useState('');
    const [defaultState, setDefaultState] = useState('');
    const [alertList, setAlertList] = useState([]);
    const [loading, setLoading] = useState(false);
    const listView = alertPlatformState?.listView ?? false;
    const [payloadData, setPayloadData]=useState({})
    const markAsCheckedError = 'mark_as_checked_error';

    const searchRequestHandler = (data) => {
        setSearchRequest(data);
    };
    const filterHandler = (value, type) => {
        const data = searchOptions[type]?.length ? searchOptions[type] : [];
        const find = data.find(d => d.id === value);
        if (type === 'group') {
            setDefaultGroup(find)
            setDefaultState({})
        }
    }
    const getSearchOptionsHandler = useCallback((type, groupParam = '') => {
        const getResponse = (type) => (response) => {
            if (response.result === "SUCCESS") {
                let filterOptions = response.data?.length ? response.data.map(r => ({ id: r.id, name: r.name })).filter(r => r.name?.toLowerCase() !== 'unknown') : [];
                if (type === 'channel') {
                    const channelIds = filterOptions.map(s => s.id);
                    filterOptions = RAW_FILTER_DATA.newchannels.map(f => { return channelIds.includes(f.id) ? f : RAW_FILTER_DATA.newchannels.find(c => c.id === f.id) })
                }
                if (type === 'group' && filterOptions?.length) {
                    setDefaultGroup(filterOptions[0])
                    dispatch(filterOptionsActions.storeFilterOptions({ key: type, options: filterOptions }))
                }
                if (type === 'location' && filterOptions?.length) {
                    setDefaultState(filterOptions[0])
                }
                if (type === 'channel') {
                    dispatch(filterOptionsActions.storeFilterOptions({ key: type, options: filterOptions }))
                }
                setSearchOptions((prev) => ({
                    ...prev,
                    [type]: [...filterOptions]
                }));
            } else {
                setSearchOptions((prev) => ({
                    ...prev,
                    [type]: []
                }));
            }
        };
        getSearchOptions(type, headers, dispatch, getResponse(type), groupParam);
    }, [dispatch, headers]);

    useEffect(() => {
        if (defaultGroup?.id) {
            getSearchOptionsHandler('location', `groups[]=${defaultGroup?.id}`);
        }
    }, [getSearchOptionsHandler, defaultGroup]);
    useEffect(() => {
        if (storedFilterOptions['group']?.length === 0) {
            getSearchOptionsHandler('group');
        } else {
            setDefaultGroup(storedFilterOptions['group'][0])
            setSearchOptions((prev) => ({
                ...prev,
                'group': [...storedFilterOptions['group']]
            }));
        }
    }, [getSearchOptionsHandler, storedFilterOptions]);


    const buildPayload = useCallback((request) => {
        const data = {};
        data.groupID = request.groupID ? request.groupID : defaultGroup?.id;
        data.stateID = request.stateID ? request.stateID : defaultState?.id;
        const startDate = request?.date?.date?.[0]
            ? moment(request.date.date[0]).format("YYYY-MM-DD")
            : moment(defaultDate[0]).format("YYYY-MM-DD");
        const endDate = request?.date?.date?.[1]
            ? moment(request.date.date[1]).format("YYYY-MM-DD")
            : moment(defaultDate[1]).format("YYYY-MM-DD");

        data.startDate = startDate;
        data.endDate = endDate;
        if(request.reviewed !== "") data.reviewed = request.reviewed;
        return data;
    }, [defaultDate, defaultGroup?.id, defaultState?.id]);
    // Get alerts  data
    const getAlertsList = useCallback((data, loading = true) => {
        let params = {};
        const selectedType = searchRequest.types
        const selectedTypes = selectedType === 'all' || !selectedType
            ? ['maxbet', 'suddenspike']
            : [selectedType];
        const alertTypes = selectedTypes.map((type) => `&types[]=${type}`).join('');
        setLoading(loading)
        setPayloadData(data)
        alertPlatform('betalerts', params, data, headers, dispatch, (response) => {
            setLoading(false);
            if (response.result === "SUCCESS") {
                const combinedAlerts = response.data;
                const responseData = Object.entries(combinedAlerts).flatMap(([type, list]) =>
                    Array.isArray(list)
                        ? list.map(item => ({
                            ...item,
                            alertDescription: type === 'maxBet' ? `Max Bet Percentage: ${item.maxBetPercentage}% \n Stake: ${currencyFormat(item.stake, defaultGroup?.id)}` : `Baseline Tournament Stake: ${currencyFormat(item.avgTournamentStake, defaultGroup?.id)} \n Event Stake: ${currencyFormat(item.eventStake, defaultGroup?.id)}`,
                            alertDescriptionSort: type === 'maxBet' ? item.maxBetPercentage : item.avgTournamentStake,
                            market: item.market || '-',
                            selection: (item.selection?.length > 40 ? item.selection.substring(0, 40) + '...' : item.selection) || '-',
                            type
                        }))
                        : []
                ).sort(
                    (a, b) => new Date(b.reportDate) - new Date(a.reportDate)
                );
                const result = responseData?.length > 0 ? responseData : [];
                if (result.length > 0) {
                    setAlertList(result);
                } else {
                    setAlertList([]);
                }
            } else {
                setAlertList([]);
            }
            setLoading(false);
        }, alertTypes);
    }, [defaultGroup?.id, dispatch, headers, searchRequest.types]);

    useEffect(() => {
        if (defaultGroup?.id && defaultState?.id) {
            const data = buildPayload(searchRequest);
            getAlertsList(data);
        }
    }, [searchRequest, buildPayload, getAlertsList, defaultGroup?.id, defaultState?.id]);
    const dateDisplay = (rowData) => {
        return (
            <div className="flex align-items-center gap-3">
                <div className="event-column">
                    <p>{DateFormat(rowData.reportDate)}</p>
                </div>
            </div>
        );
    };
    const eventTournamentDisplay = (rowData) => {
        const trimmedEventName = rowData.eventName?.length > 65 ? rowData.eventName.substring(0, 65) + '...' : rowData.eventName;
        return (
            <div className="flex align-items-center gap-3">
                <div className="event-column">
                    <p>{trimmedEventName}</p>
                    <span>{rowData.tournamentName}</span>
                </div>
            </div>
        );
    };
    const marketSelectionDisplay = (rowData) => {
        if (rowData.market === '-' && rowData.selection === '-') {
            return (
                <div className="flex align-items-center gap-3">
                    <div className="event-column">
                        <p>-</p>
                    </div>
                </div>
            )
        }
        return (
            <div className="flex align-items-center gap-3">
                <div className="event-column">
                    <p>{rowData.selection}</p>
                    <span>{rowData.market}</span>
                </div>
            </div>
        );
    };
    const playerDisplay = (rowData) => {
        return (
            <div className="flex align-items-center gap-3">
                <div className="event-column">
                    {rowData?.playerID ?
                        <p className="underline cursorPointer" onClick={() => navigate(`/player-analytics/${rowData.playerID}`, { state: { date: alertPlatformState?.date?.date } })}>{rowData?.playerID}</p> : '-'}
                </div>
            </div>
        );
    }
    const displayAlertType = (rowData) => {
        return (
            <div className="flex align-items-center gap-3">
                {alertTypes[rowData.type]?.replace(" Alert", "")}
            </div>
        );
    }
    const alertDescriptionDisplay = (rowData) => {

        if (rowData.type === 'maxBet') {
          const maxalert = rowData.alertDescription.split('\n');
            return (
                <div className="event-column">
                <p>{maxalert[0]}</p>
                {maxalert[1] && <span>{maxalert[1].trim()}</span>}
            </div>
            )
        }
        const parts = rowData.alertDescription.split('\n');
        return (
            <div className="event-column">
                <p>{parts[0]}</p>
                {parts[1] && <span>{parts[1].trim()}</span>}
            </div>
        )
    }
    const action = (rowData) => {
        return (
            <>
                <PR.Button icon="pi pi-eye" className="view-button eye-icon"
                    onClick={() => {
                        if (rowData.type === 'maxBet') {
                            return navigate(`/bet-details/${rowData.reportID}`, { state: { type: 'anomalies', groupId: defaultGroup?.id } })
                        } else if (rowData.type === 'suddenSpike') {
                            return navigate(`/event-bet-list`, { state: { type: 'anomalies', searchRequest: { ...payloadData, events: [rowData.eventName] }, event: rowData.eventName } })
                        }
                    }}
                />
                <PR.InputSwitch
                    checked={rowData.reviewed}
                    className="anomalies-inputswitch ml-2"
                    onChange={() => handleMarkAsChecked(rowData)}
                    tooltip={rowData.reviewed ? "Reviewed" : "Mark as Reviewed"}
                    tooltipOptions={{ position: 'bottom', className: 'reviewed-tooltip-modal' }}
                />
            </>
        );
    };
    const filterAlertsByPayload = useCallback((alerts, payload) => {
        let filteredAlerts = Array.isArray(alerts) ? [...alerts] : [];

        if (payload?.reviewed !== undefined && payload?.reviewed !== "") {
            filteredAlerts = filteredAlerts.filter((item) => item.reviewed === payload.reviewed);
        }

        return filteredAlerts;
    }, []);

    const handleMarkAsChecked = (rowData) => {
        const updatedCheckedStatus = !rowData.reviewed;
        const request = {
            betAlertID: rowData.betAlertID,
            alertType: rowData.type?.toLowerCase(),
            reviewed: updatedCheckedStatus
        }
        markAsCheckedAPI(request, headers, dispatch, (response) => {
            if (response.result === "SUCCESS") {
                const updatedPayload = buildPayload(searchRequest);
                setAlertList((prevData) => {
                    const updatedAlerts = prevData.map((item) =>
                        item.betAlertID === rowData.betAlertID && item.type === rowData.type ? { ...item, reviewed: updatedCheckedStatus } : item
                    );
                    return filterAlertsByPayload(updatedAlerts, updatedPayload);
                });
                const message = updatedCheckedStatus ? "Alert marked as reviewed successfully" : "Alert marked as unreviewed successfully";
                showToast("success", message)
            } else {
                const message = rowData.reviewed ? "Failed to mark as unreviewed. Please try again" : "Failed to mark as reviewed. Please try again";
                showToast("warn", message, markAsCheckedError)
            }
        });
    }

    return (
        <>
            <section className="analyst-home-section statistics-betting-section">
                <SearchAndTotalSummary searchRequestHandler={searchRequestHandler} filterHandler={filterHandler} totalData={{}} searchOptions={searchOptions} loading={false} alertPlatformState={alertPlatformState} defaultDate={defaultDate} defaultGroup={defaultGroup} defaultState={defaultState} screenType={'anomalies'} />
                <Layout>

                    <section className='anomalies-history-section'>
                        <div className="displayGrid">
                            <div className="m-0">
                                <h1>Anomalies
                                     <span className="white-space-nowrap alert-count">
                                        (<PR.Image src={lightBulb} alt="Alert Notifications" className="notifications-icon" />
                                        {alertList.length > pageDisplayCount ? `${pageDisplayCount}+ Matching alerts detected. Narrow the time window to see more.` : `${alertList.length} Matching alerts detected`} )
                                    </span>
                                </h1>
                            </div>
                            <div className="anomalies-filter-section flex gap-2">
                                <PR.ToggleButton onLabel="List View" offLabel="Grid view" onIcon="pi pi-list" offIcon="pi pi-table"
                                    checked={listView} onChange={(e) => dispatch(storeAnomalieFilters({ listView: e.value }))} className="search-filters-button" />
                            </div>
                        </div>

                        {listView &&
                            <PR.DataTable value={alertList?.slice(0, pageDisplayCount)} loading={loading} stripedRows className="data-table anomalies-list-view" sortField="reportDate" sortOrder={-1}>
                                <PR.Column body={dateDisplay} field="reportDate" header="Date" className="date-column" sortable />
                                <PR.Column body={displayAlertType} field="type" header="Alert Type" className="alert-type-column" sortable />
                                <PR.Column body={alertDescriptionDisplay} field="alertDescription" sortField="alertDescriptionSort" header="Alert Description" className="alert-desc-column" sortable />
                                <PR.Column body={playerDisplay} field="playerID" header="PlayerID" sortable />
                                <PR.Column body={eventTournamentDisplay} field="eventName" header="Event / Tournament" className="event-column" sortable />
                                <PR.Column body={marketSelectionDisplay} field="market" header="Market / Selection" sortable />
                                <PR.Column field="sportName" header="Sport" sortable className="sport-column" />
                                {<PR.Column body={action} header="Action" className="action-column" />}
                            </PR.DataTable>
                        }
                        {
                            !listView &&
                            <AlertNotifications alertListData={alertList} loading={loading}  searchRequest={payloadData} isLoading={loading} modalHandler={handleMarkAsChecked} groupId={defaultGroup?.id}/>
                        }

                    </section>

                </Layout>
            </section>
        </>
    );
}

export default Anomalies;
